webpackJsonp([79611799117203,60335399758886],{

/***/ 636:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"GRS logistics","copyright":"© 2014 Grs Logistics"}},"contacts":{"phoneNumbers":["8 848 271 47 03"],"address":"г. Тольятти, Самарская обл., Южное шоссе 73, оф. 204","email":"info@grslogistics.ru"},"services":{"edges":[{"node":{"title":"Перевозки морем","fields":{"slug":"/services/sea-shipment"}}},{"node":{"title":"Авиаперевозки","fields":{"slug":"/services/air-shipment"}}},{"node":{"title":"Автоперевозки","fields":{"slug":"/services/auto-shipment"}}},{"node":{"title":"Ж/Д перевозки по России","fields":{"slug":"/services/railways-shipment"}}},{"node":{"title":"Сборные грузы","fields":{"slug":"/services/combined-shipment"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(1093);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(636);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(78);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(78);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(78);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(317);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(316);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(128);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(128);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(318);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function LogoRgb (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"logo_rgb"),React.createElement("polygon",{"points":"226.5 533.54 0 402.77 0 141.23 242 0 241.5 98.33 84 189.73 84 354.27 226.5 436.55 369 354.27 369 248.16 241 317.38 240.86 224 453 98.8 453 402.77 226.5 533.54","fill":"#0069a6","key":1}),React.createElement("path",{"d":"M680.87,227.36H822.23V385.15q-57.58,17.62-126.57,17.62-75.72,0-117.05-39.25T537.27,251.59q0-70.89,45.25-110.33t126.8-39.45A313,313,0,0,1,767.68,107q27.44,5.21,47.83,13.22l-28,62.08q-35.4-15.62-77.74-15.62-38.76,0-59.93,22.53t-21.17,64.38q0,41.05,19.15,62.58t55.22,21.53a180.58,180.58,0,0,0,36.29-3.4V288.43H680.87Z","fill":"#231f20","key":2}),React.createElement("path",{"d":"M1000.42,292.24V398.77H911.93V106h107.31q133.52,0,133.52,86.51,0,50.86-55.56,78.7l95.43,127.56H1092.27l-69.45-106.53Zm0-59.47H1017q46.37,0,46.37-36.64,0-30.23-45.48-30.24h-17.47Z","fill":"#231f20","key":3}),React.createElement("path",{"d":"M1459.54,309.86q0,27.24-15.46,48.36t-44.58,32.84q-29.12,11.71-68.33,11.72-32.71,0-54.89-4.11a220.46,220.46,0,0,1-46.15-14.32V313.86A283,283,0,0,0,1282.78,332q27.33,6.51,50.18,6.51,19.71,0,28.9-6.11t9.19-15.72a16.08,16.08,0,0,0-3.7-10.51q-3.7-4.51-11.87-9.11t-43.57-18.82q-32-13-48.05-25.23t-23.75-28q-7.73-15.82-7.73-37.45,0-40.45,32.93-63.08t90.51-22.63q50.85,0,103.72,21l-27.11,61.07q-45.93-18.82-79.3-18.82-17.25,0-25.09,5.41t-7.84,13.42q0,8.61,10,15.42t54.1,24.83q42.34,17,58.81,36.54T1459.54,309.86Z","fill":"#231f20","key":4}),React.createElement("path",{"d":"M543.27,563.45v-106h15V552.2H606v11.25Z","fill":"#0069a6","key":5}),React.createElement("path",{"d":"M716.22,566.1q-22.57,0-36.08-15.15t-13.51-40.52q0-25.37,13.51-40.52t36.08-15.16q22.57,0,36.07,15.16t13.51,40.52q0,25.36-13.51,40.52T716.22,566.1Zm0-11.25q15.83,0,24.72-11.79t8.88-32.78q0-20.85-8.88-32.57T716.22,466q-15.84,0-24.72,11.71t-8.88,32.57q0,21,8.88,32.78T716.22,554.85Z","fill":"#0069a6","key":6}),React.createElement("path",{"d":"M917.9,560.58q-19.28,5.51-33.6,5.52-25.29,0-38.8-14.37T832,510.43q0-26.51,13.72-41.09t38.58-14.58a126.36,126.36,0,0,1,33.46,4.8v13.9Q895.83,466,884.15,466q-17.2,0-26.69,11.64T848,510.49q0,21,10.16,32.67t28.48,11.68a56.06,56.06,0,0,0,16.24-2.65V517.66h15Z","fill":"#0069a6","key":7}),React.createElement("path",{"d":"M995.55,563.45v-106h15v106Z","fill":"#0069a6","key":8}),React.createElement("path",{"d":"M1082.73,561.44v-14.9q17.91,8.31,29.52,8.31,8.81,0,14.22-4.69a15.41,15.41,0,0,0,5.41-12.22,16.29,16.29,0,0,0-3.55-10.6q-3.55-4.37-13.08-9.75l-7.31-4.23q-13.54-7.74-19.09-14.58a24.45,24.45,0,0,1-5.55-15.87,25.9,25.9,0,0,1,8.88-20.24q8.88-7.92,22.64-7.92a90.07,90.07,0,0,1,25.87,4.08v13.76q-16.77-6.59-25-6.59-7.81,0-12.9,4.16a13,13,0,0,0-5.09,10.46,13.52,13.52,0,0,0,3.73,9.39q3.72,4.08,13.61,9.74l7.6,4.3q13.76,7.81,19.2,14.76a26.26,26.26,0,0,1,5.45,16.7q0,13.83-10.17,22.21t-27,8.38Q1099.36,566.1,1082.73,561.44Z","fill":"#0069a6","key":9}),React.createElement("path",{"d":"M1244.86,563.45V468.65h-37.62V457.4h90.28v11.25h-37.62v94.79Z","fill":"#0069a6","key":10}),React.createElement("path",{"d":"M1363.72,563.45v-106h15v106Z","fill":"#0069a6","key":11}),React.createElement("path",{"d":"M1537.09,558a73.58,73.58,0,0,1-34.25,8.1q-24.72,0-38.19-14.47t-13.47-41.13q0-26.58,13.72-41.16t38.73-14.58q14.19,0,33.32,4.66v14.12q-21.78-7.52-33.6-7.52-17.27,0-26.73,11.68t-9.46,33q0,20.35,10.1,32t27.66,11.68q15,0,32.17-9.24Z","fill":"#0069a6","key":12}),React.createElement("path",{"d":"M1603.78,561.44v-14.9q17.91,8.31,29.52,8.31,8.81,0,14.22-4.69a15.41,15.41,0,0,0,5.41-12.22,16.29,16.29,0,0,0-3.55-10.6q-3.55-4.37-13.08-9.75l-7.31-4.23q-13.54-7.74-19.09-14.58a24.45,24.45,0,0,1-5.55-15.87,25.9,25.9,0,0,1,8.88-20.24q8.88-7.92,22.64-7.92a90.07,90.07,0,0,1,25.87,4.08v13.76q-16.77-6.59-25-6.59-7.81,0-12.9,4.16a13,13,0,0,0-5.09,10.46,13.52,13.52,0,0,0,3.73,9.39q3.72,4.08,13.61,9.74l7.6,4.3q13.76,7.81,19.2,14.76a26.26,26.26,0,0,1,5.45,16.7q0,13.83-10.17,22.21t-27,8.38Q1620.41,566.1,1603.78,561.44Z","fill":"#0069a6","key":13})]);
	}
	
	LogoRgb.displayName = "LogoRgb";
	
	LogoRgb.defaultProps = {"id":"Слой_1","data-name":"Слой 1","viewBox":"0 0 1668.34 566.1"};
	
	module.exports = LogoRgb;
	
	LogoRgb.default = LogoRgb;


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BodyScrollLock = function (_Component) {
	  _inherits(BodyScrollLock, _Component);
	
	  function BodyScrollLock() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BodyScrollLock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setLocked = function (locked) {
	      if (!_this.$body) return;
	
	      if (locked) {
	        _this.$body.classList.add('body-scroll-lock');
	      } else {
	        _this.$body.classList.remove('body-scroll-lock');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BodyScrollLock.prototype.componentDidUpdate = function componentDidUpdate(_ref) {
	    var locked = _ref.locked;
	
	    if (locked !== this.props.locked) {
	      this.setLocked(this.props.locked);
	    }
	  };
	
	  BodyScrollLock.prototype.componentDidMount = function componentDidMount() {
	    var locked = this.props.locked;
	
	    this.$body = document.querySelector('body');
	    this.setLocked(locked);
	  };
	
	  BodyScrollLock.prototype.render = function render() {
	    return null;
	  };
	
	  return BodyScrollLock;
	}(_react.Component);
	
	BodyScrollLock.propTypes = {
	  locked: _propTypes2.default.bool
	};
	exports.default = BodyScrollLock;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _bodyScrollLock = __webpack_require__(198);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bodyScrollLock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transform: translate3d(0, 0, 0);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, ', ');\n  z-index: 2;\n  transition: all 0.4s;\n  opacity: ', ';\n  pointer-events: ', ';\n'], ['\n  transform: translate3d(0, 0, 0);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, ', ');\n  z-index: 2;\n  transition: all 0.4s;\n  opacity: ', ';\n  pointer-events: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  max-height: ', 'px;\n  overflow-y: auto;\n  transform: translate3d(0, 0, 0);\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  height: 100%;\n  max-height: ', 'px;\n  overflow-y: auto;\n  transform: translate3d(0, 0, 0);\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(319);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _flag = __webpack_require__(177);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _windowHeight = __webpack_require__(203);
	
	var _windowHeight2 = _interopRequireDefault(_windowHeight);
	
	var _bodyScrollLock = __webpack_require__(199);
	
	var _bodyScrollLock2 = _interopRequireDefault(_bodyScrollLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Dialog.propTypes = {
	  renderTrigger: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.func.isRequired,
	  backdropOpacity: _propTypes2.default.number
	};
	
	function Dialog(_ref) {
	  var renderTrigger = _ref.renderTrigger,
	      _ref$backdropOpacity = _ref.backdropOpacity,
	      backdropOpacity = _ref$backdropOpacity === undefined ? 0.7 : _ref$backdropOpacity,
	      renderBody = _ref.children;
	
	  return _react2.default.createElement(
	    _flag2.default,
	    null,
	    function (_ref2) {
	      var isOn = _ref2.isOn,
	          setOn = _ref2.setOn,
	          setOff = _ref2.setOff;
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        renderTrigger({ open: setOn }),
	        _react2.default.createElement(
	          _reactPortal.Portal,
	          null,
	          _react2.default.createElement(
	            Backdrop,
	            { opacity: backdropOpacity, open: isOn, onClick: setOff },
	            _react2.default.createElement(_bodyScrollLock2.default, { locked: isOn }),
	            _react2.default.createElement(
	              _windowHeight2.default,
	              null,
	              function (height) {
	                return _react2.default.createElement(
	                  Inner,
	                  { height: height },
	                  renderBody({ close: setOff, isOpened: isOn })
	                );
	              }
	            )
	          )
	        )
	      );
	    }
	  );
	}
	
	exports.default = Dialog;
	
	
	var Backdrop = _styledComponents2.default.div(_templateObject, function (_ref3) {
	  var opacity = _ref3.opacity;
	  return opacity;
	}, function (_ref4) {
	  var open = _ref4.open;
	  return open ? 1 : 0;
	}, function (_ref5) {
	  var open = _ref5.open;
	  return open ? 'all' : 'none';
	});
	
	var Inner = _styledComponents2.default.div(_templateObject2, function (_ref6) {
	  var height = _ref6.height;
	  return height;
	});
	module.exports = exports['default'];

/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 80px;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 80px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ', ';\n  color: #fff;\n'], ['\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ', ';\n  color: #fff;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: none;\n  ', ';\n'], ['\n  display: none;\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: inline;\n  cursor: pointer;\n  ', ';\n'], ['\n  display: inline;\n  cursor: pointer;\n  ', ';\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledComponentsBreakpoint = __webpack_require__(37);
	
	var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _reset = __webpack_require__(10);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _menu = __webpack_require__(1045);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _layout = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Footer.propTypes = {
	  copyright: _propTypes2.default.string.isRequired,
	  menu: _propTypes2.default.array.isRequired
	};
	
	function Footer(_ref) {
	  var copyright = _ref.copyright,
	      menu = _ref.menu;
	
	  return _react2.default.createElement(
	    Outer,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Copyright,
	        null,
	        copyright
	      ),
	      _react2.default.createElement(
	        BackOnTop,
	        { onClick: scrollOnTop },
	        '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0432\u0435\u0440\u0445'
	      ),
	      _react2.default.createElement(Menu, { dropdownOnTop: true, items: menu })
	    )
	  );
	}
	
	exports.default = Footer;
	
	
	var Container = (0, _styledComponents2.default)(_layout.Container)(_templateObject);
	
	var Outer = _styledComponents2.default.div(_templateObject2, _colors2.default.black);
	
	var Copyright = _styledComponents2.default.p(_templateObject3, _reset2.default.p);
	
	var Menu = (0, _styledComponents2.default)(_menu2.default)(_templateObject4, (0, _styledComponentsBreakpoint2.default)('l')(_templateObject5));
	
	var BackOnTop = _styledComponents2.default.span(_templateObject6, (0, _styledComponentsBreakpoint2.default)('l')(_templateObject7));
	
	function scrollOnTop() {
	  window.scrollTo(0, 0);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  box-shadow: 0 1px 3px ', ';\n'], ['\n  position: relative;\n  box-shadow: 0 1px 3px ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(178);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _layout = __webpack_require__(15);
	
	var _logo = __webpack_require__(517);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _preheader = __webpack_require__(1074);
	
	var _preheader2 = _interopRequireDefault(_preheader);
	
	var _preheaderItem = __webpack_require__(1073);
	
	var _preheaderItem2 = _interopRequireDefault(_preheaderItem);
	
	var _menu = __webpack_require__(1045);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _mobileMenu = __webpack_require__(1072);
	
	var _mobileMenu2 = _interopRequireDefault(_mobileMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Header.propTypes = {
	  children: _propTypes2.default.func,
	  menu: _propTypes2.default.array,
	  phoneNumber: _propTypes2.default.string.isRequired,
	  address: _propTypes2.default.string.isRequired,
	  email: _propTypes2.default.string.isRequired
	};
	
	function Header(_ref) {
	  var children = _ref.children,
	      menu = _ref.menu,
	      phoneNumber = _ref.phoneNumber,
	      email = _ref.email,
	      address = _ref.address;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _preheader2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_preheaderItem2.default, {
	          label: phoneNumber,
	          icon: 'phone-square',
	          url: getNumberUrl(phoneNumber)
	        }),
	        _react2.default.createElement(_preheaderItem2.default, {
	          label: email,
	          icon: 'envelope',
	          url: 'mailto:' + email
	        })
	      ),
	      _react2.default.createElement(_preheaderItem2.default, { label: address, icon: 'map-marker-alt', url: '/contacts' })
	    ),
	    _react2.default.createElement(
	      HeaderWrapper,
	      null,
	      _react2.default.createElement(
	        HeaderContainer,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement(_logo2.default, null)
	        ),
	        _react2.default.createElement(_menu2.default, { items: menu }),
	        _react2.default.createElement(_mobileMenu2.default, { items: menu })
	      )
	    )
	  );
	}
	
	exports.default = Header;
	
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject, _colors2.default.shadow);
	
	var HeaderContainer = (0, _styledComponents2.default)(_layout.Container)(_templateObject2);
	var getNumberUrl = function getNumberUrl(number) {
	  return 'tel:' + number.replace(/[+()\- ]/g, '');
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _header = __webpack_require__(1070);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_header).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transition: all 0.1s;\n  transform: rotateZ(', ');\n'], ['\n  transition: all 0.1s;\n  transform: rotateZ(', ');\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n  outline: none;\n  ', ';\n'], ['\n  ', ';\n  outline: none;\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ';\n  position: relative;\n  transition: all 0.2s;\n  background-color: #121314;\n'], ['\n  ', ';\n  position: relative;\n  transition: all 0.2s;\n  background-color: #121314;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: block;\n  color: #9fa4af;\n  padding: 1.125rem 1.5rem 1.125rem 2.8rem;\n  border-bottom: 1px solid #25262a;\n  border-top: 1px solid #25262a;\n  margin-bottom: -1px;\n  cursor: pointer;\n  &:hover {\n    color: #f5f6f8;\n  }\n'], ['\n  ', ';\n  display: block;\n  color: #9fa4af;\n  padding: 1.125rem 1.5rem 1.125rem 2.8rem;\n  border-bottom: 1px solid #25262a;\n  border-top: 1px solid #25262a;\n  margin-bottom: -1px;\n  cursor: pointer;\n  &:hover {\n    color: #f5f6f8;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  transition: all 0.2s;\n  position: absolute;\n  top: 0;\n  left: ', ';\n  width: 80vw;\n  height: 100vh;\n  overflow-y: auto;\n  background-color: #191a1e;\n  ', ';\n'], ['\n  transition: all 0.2s;\n  position: absolute;\n  top: 0;\n  left: ', ';\n  width: 80vw;\n  height: 100vh;\n  overflow-y: auto;\n  background-color: #191a1e;\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    width: 50vw;\n  '], ['\n    width: 50vw;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  ', ';\n  padding-bottom: 4rem;\n'], ['\n  ', ';\n  padding-bottom: 4rem;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ', ';\n  padding: 1.125rem 1.5rem;\n  border-bottom: 1px solid #25262a;\n  border-top: 1px solid #25262a;\n  margin-bottom: -1px;\n  transition: all 0.2s;\n  background-color: ', ';\n  cursor: pointer;\n  &:hover {\n    color: #f5f6f8;\n  }\n'], ['\n  ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ', ';\n  padding: 1.125rem 1.5rem;\n  border-bottom: 1px solid #25262a;\n  border-top: 1px solid #25262a;\n  margin-bottom: -1px;\n  transition: all 0.2s;\n  background-color: ', ';\n  cursor: pointer;\n  &:hover {\n    color: #f5f6f8;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCollapse = __webpack_require__(494);
	
	var _styledComponentsBreakpoint = __webpack_require__(37);
	
	var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);
	
	var _gatsbyLink = __webpack_require__(178);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _flag = __webpack_require__(177);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _icon = __webpack_require__(82);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _reset = __webpack_require__(10);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _dialog = __webpack_require__(200);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _utils = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileMenu = function (_Component) {
	  _inherits(MobileMenu, _Component);
	
	  function MobileMenu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MobileMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderSubmenuItem = function (closeMenu) {
	      return function (_ref, i) {
	        var label = _ref.label,
	            url = _ref.url;
	
	        var key = i + ':' + url + ':' + label;
	        return _react2.default.createElement(
	          SubmenuItem,
	          { key: key },
	          _react2.default.createElement(
	            SubmenuLink,
	            { to: url, onClick: closeMenu },
	            label
	          )
	        );
	      };
	    }, _this.renderItem = function (closeMenu) {
	      return function (_ref2, i) {
	        var label = _ref2.label,
	            url = _ref2.url,
	            children = _ref2.children;
	
	        var key = i + ':' + url + ':' + label;
	        return children ? _react2.default.createElement(
	          _flag2.default,
	          { key: key },
	          function (_ref3) {
	            var isOn = _ref3.isOn,
	                toggle = _ref3.toggle;
	            return _react2.default.createElement(
	              MenuItem,
	              null,
	              _react2.default.createElement(
	                MenuBrowserLink,
	                { href: '#', open: isOn, onClick: toggle },
	                label,
	                _react2.default.createElement(Icon, { icon: 'angle-right', open: isOn })
	              ),
	              _react2.default.createElement(
	                _reactCollapse.Collapse,
	                {
	                  isOpened: isOn,
	                  springConfig: { stiffness: 300, damping: 30 }
	                },
	                _react2.default.createElement(
	                  SubmenuList,
	                  null,
	                  children.map(_this.renderSubmenuItem(closeMenu))
	                )
	              )
	            );
	          }
	        ) : _react2.default.createElement(
	          MenuItem,
	          { key: key },
	          _react2.default.createElement(
	            MenuLink,
	            { to: url, onClick: closeMenu },
	            label
	          )
	        );
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MobileMenu.prototype.render = function render() {
	    var _this2 = this;
	
	    var items = this.props.items;
	
	    return _react2.default.createElement(
	      _dialog2.default,
	      {
	        backdropOpacity: 0.3,
	        renderTrigger: function renderTrigger(_ref4) {
	          var open = _ref4.open;
	          return _react2.default.createElement(
	            Button,
	            { onClick: open },
	            _react2.default.createElement(Icon, { icon: 'bars', size: 'lg' })
	          );
	        }
	      },
	      function (_ref5) {
	        var isOpened = _ref5.isOpened,
	            close = _ref5.close;
	        return _react2.default.createElement(
	          MenuWrapper,
	          { open: isOpened },
	          _react2.default.createElement(
	            MenuList,
	            { onClick: _utils.stopPropagation },
	            items.map(_this2.renderItem(close))
	          )
	        );
	      }
	    );
	  };
	
	  return MobileMenu;
	}(_react.Component);
	
	MobileMenu.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string,
	    children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.string.isRequired,
	      url: _propTypes2.default.string.isRequired
	    }))
	  }))
	};
	exports.default = MobileMenu;
	
	
	var Icon = (0, _styledComponents2.default)(_icon2.default)(_templateObject, function (_ref6) {
	  var open = _ref6.open;
	  return open ? '90deg' : '0';
	});
	
	var Button = _styledComponents2.default.button(_templateObject2, _reset2.default.button, (0, _styledComponentsBreakpoint2.default)('l')(_templateObject3));
	
	var SubmenuList = _styledComponents2.default.ul(_templateObject4, _reset2.default.ul);
	
	var SubmenuItem = _styledComponents2.default.li(_templateObject5, _reset2.default.li);
	
	var SubmenuLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject6, _reset2.default.a);
	
	var MenuWrapper = _styledComponents2.default.div(_templateObject7, function (_ref7) {
	  var open = _ref7.open;
	  return open ? 0 : '-100%';
	}, (0, _styledComponentsBreakpoint2.default)('m')(_templateObject8));
	
	var MenuList = _styledComponents2.default.ul(_templateObject9, _reset2.default.ul);
	
	var MenuItem = _styledComponents2.default.li(_templateObject5, _reset2.default.li);
	
	var MenuLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject10, _reset2.default.a, function (_ref8) {
	  var open = _ref8.open;
	  return open ? '#f5f6f8' : '#848994';
	}, function (_ref9) {
	  var open = _ref9.open;
	  return open ? '#121314' : 'transparent';
	});
	
	var MenuBrowserLink = MenuLink.withComponent('a');
	module.exports = exports['default'];

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.2s;\n  color: ', ' !important;\n  font-size: 0.75rem;\n  border: none;\n  margin-right: 2.25rem;\n  &:last-child {\n    margin-right: 0;\n  }\n  &:hover {\n    cursor: pointer;\n    color: ', ' !important;\n    border: none;\n  }\n'], ['\n  ', ';\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.2s;\n  color: ', ' !important;\n  font-size: 0.75rem;\n  border: none;\n  margin-right: 2.25rem;\n  &:last-child {\n    margin-right: 0;\n  }\n  &:hover {\n    cursor: pointer;\n    color: ', ' !important;\n    border: none;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  align-items: center;\n  color: ', ';\n  font-size: 0.75rem;\n  margin-right: 2.25rem;\n  &:last-child {\n    margin-right: 0;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  color: ', ';\n  font-size: 0.75rem;\n  margin-right: 2.25rem;\n  &:last-child {\n    margin-right: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-left: 0.5rem;\n'], ['\n  margin-left: 0.5rem;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ui = __webpack_require__(56);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _icon = __webpack_require__(82);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _reset = __webpack_require__(10);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	PreheaderItem.propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string
	};
	
	function PreheaderItem(_ref) {
	  var label = _ref.label,
	      icon = _ref.icon,
	      url = _ref.url;
	
	  var ContainerComponent = url ? Link : Span;
	
	  return _react2.default.createElement(
	    ContainerComponent,
	    { href: url },
	    _react2.default.createElement(_icon2.default, { icon: icon }),
	    _react2.default.createElement(
	      Label,
	      null,
	      label
	    )
	  );
	}
	
	exports.default = PreheaderItem;
	
	
	var Link = (0, _styledComponents2.default)(_ui.Link)(_templateObject, _reset2.default.a, _colors2.default.textLight, _colors2.default.primary);
	
	var Span = _styledComponents2.default.span(_templateObject2, _colors2.default.textLight);
	
	var Label = _styledComponents2.default.span(_templateObject3);
	module.exports = exports['default'];

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  background: ', ';\n  box-shadow: 0 0 1px ', ';\n  ', ';\n'], ['\n  display: none;\n  background: ', ';\n  box-shadow: 0 0 1px ', ';\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledComponentsBreakpoint = __webpack_require__(37);
	
	var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);
	
	var _layout = __webpack_require__(15);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Preheader.propTypes = {
	  children: _propTypes2.default.any
	};
	
	function Preheader(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    PreheaderWrapper,
	    null,
	    _react2.default.createElement(
	      PreheaderContainer,
	      null,
	      children
	    )
	  );
	}
	
	exports.default = Preheader;
	
	
	var PreheaderWrapper = _styledComponents2.default.div(_templateObject, _colors2.default.lightGray, _colors2.default.shadow, (0, _styledComponentsBreakpoint2.default)('m')(_templateObject2));
	
	var PreheaderContainer = (0, _styledComponents2.default)(_layout.Container)(_templateObject3);
	module.exports = exports['default'];

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 45px;\n'], ['\n  height: 45px;\n']);
	
	var _logoRgb = __webpack_require__(1029);
	
	var _logoRgb2 = _interopRequireDefault(_logoRgb);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = (0, _styledComponents2.default)(_logoRgb2.default)(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n  z-index: 2;\n  position: absolute;\n  left: 0;\n  background: ', ';\n  opacity: 0;\n  transition: all 0.2s;\n  box-shadow: 0 1px 3px ', ';\n  pointer-events: none;\n  color: ', ';\n'], ['\n  ', ';\n  z-index: 2;\n  position: absolute;\n  left: 0;\n  background: ', ';\n  opacity: 0;\n  transition: all 0.2s;\n  box-shadow: 0 1px 3px ', ';\n  pointer-events: none;\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: block;\n'], ['\n  ', ';\n  display: block;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: block;\n  padding: 0.5em 1rem;\n  white-space: nowrap;\n  transition: all 0.2s;\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  ', ';\n  display: block;\n  padding: 0.5em 1rem;\n  white-space: nowrap;\n  transition: all 0.2s;\n  &:hover {\n    color: ', ';\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: none;\n  font-size: 1rem;\n  ', ';\n'], ['\n  ', ';\n  display: none;\n  font-size: 1rem;\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  ', ';\n  position: relative;\n  margin-left: 1.5em;\n  ', ' {\n    opacity: 0;\n    ', ';\n  }\n  &:hover ', ' {\n    pointer-events: initial;\n    opacity: 1;\n  }\n'], ['\n  ', ';\n  position: relative;\n  margin-left: 1.5em;\n  ', ' {\n    opacity: 0;\n    ', ';\n  }\n  &:hover ', ' {\n    pointer-events: initial;\n    opacity: 1;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ', ';\n  display: flex;\n  align-items: center;\n  padding: 0.5em 0;\n  transition: all 0.2s;\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  ', ';\n  display: flex;\n  align-items: center;\n  padding: 0.5em 0;\n  transition: all 0.2s;\n  &:hover {\n    color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledComponentsBreakpoint = __webpack_require__(37);
	
	var _styledComponentsBreakpoint2 = _interopRequireDefault(_styledComponentsBreakpoint);
	
	var _gatsbyLink = __webpack_require__(178);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reset = __webpack_require__(10);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _icon = __webpack_require__(82);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderDropdownItem = function (_ref, i) {
	      var label = _ref.label,
	          url = _ref.url;
	
	      var key = i + ':' + url + ':' + label;
	      return _react2.default.createElement(
	        DropdownItem,
	        { key: key },
	        _react2.default.createElement(
	          DropdownLink,
	          { to: url },
	          label
	        )
	      );
	    }, _this.renderItem = function (_ref2, i) {
	      var label = _ref2.label,
	          _ref2$url = _ref2.url,
	          url = _ref2$url === undefined ? '#' : _ref2$url,
	          children = _ref2.children;
	
	      var key = i + ':' + url + ':' + label;
	      var dropdownOnTop = _this.props.dropdownOnTop;
	
	      return _react2.default.createElement(
	        MenuItem,
	        { key: key, dropdownOnTop: dropdownOnTop },
	        _react2.default.createElement(
	          MenuLink,
	          { to: url },
	          label,
	          children && _react2.default.createElement(_icon2.default, { style: iconStyle, icon: 'chevron-down', size: 'xs' })
	        ),
	        children && _react2.default.createElement(
	          DropdownList,
	          null,
	          children.map(_this.renderDropdownItem)
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Menu.prototype.render = function render() {
	    var _props = this.props,
	        items = _props.items,
	        props = _objectWithoutProperties(_props, ['items']);
	
	    return _react2.default.createElement(
	      MenuList,
	      props,
	      items.map(this.renderItem)
	    );
	  };
	
	  return Menu;
	}(_react.Component);
	
	Menu.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string,
	    children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.string.isRequired,
	      url: _propTypes2.default.string.isRequired
	    }))
	  })),
	  dropdownOnTop: _propTypes2.default.bool
	};
	exports.default = Menu;
	
	
	var iconStyle = { marginLeft: '0.5rem' };
	
	var DropdownList = _styledComponents2.default.ul(_templateObject, _reset2.default.ul, _colors2.default.background, _colors2.default.shadow, _colors2.default.text);
	
	var DropdownItem = _styledComponents2.default.li(_templateObject2, _reset2.default.li);
	
	var DropdownLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3, _reset2.default.a, _colors2.default.primary);
	
	var MenuList = _styledComponents2.default.ul(_templateObject4, _reset2.default.ul, (0, _styledComponentsBreakpoint2.default)('l')(_templateObject5));
	
	var MenuItem = _styledComponents2.default.li(_templateObject6, _reset2.default.li, DropdownList, getPosition(95, 95), DropdownList);
	
	var MenuLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject7, _reset2.default.a, _colors2.default.primary);
	
	function getPosition(bottom, top) {
	  return function (_ref3) {
	    var dropdownOnTop = _ref3.dropdownOnTop;
	    return dropdownOnTop ? 'bottom: ' + bottom + '%;' : 'top: ' + top + '%;';
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _meta = __webpack_require__(131);
	
	var _breakpoints = __webpack_require__(541);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = {
	  breakpoints: _breakpoints2.default
	};
	
	RootProvider.propTypes = {
	  children: _propTypes2.default.any.isRequired,
	  titlePrefix: _propTypes2.default.string.isRequired
	};
	
	function RootProvider(_ref) {
	  var children = _ref.children,
	      titlePrefix = _ref.titlePrefix;
	
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: theme },
	    _react2.default.createElement(
	      _meta.TitleProvider,
	      { prefix: titlePrefix },
	      children
	    )
	  );
	}
	
	exports.default = RootProvider;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowHeight = function (_Component) {
	  _inherits(WindowHeight, _Component);
	
	  function WindowHeight() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WindowHeight);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.onResize = function () {
	      _this.setState({ height: window.innerHeight });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WindowHeight.prototype.attachListener = function attachListener() {
	    window.addEventListener('resize', this.onResize);
	  };
	
	  WindowHeight.prototype.detachListener = function detachListener() {
	    window.removeEventListener('resize', this.onResize);
	  };
	
	  WindowHeight.prototype.componentDidMount = function componentDidMount() {
	    this.attachListener();
	    this.setState({ height: window.innerHeight });
	  };
	
	  WindowHeight.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.detachListener();
	  };
	
	  WindowHeight.prototype.render = function render() {
	    var renderChildren = this.props.children;
	
	    return this.state.height === null ? null : renderChildren(this.state.height);
	  };
	
	  return WindowHeight;
	}(_react.Component);
	
	WindowHeight.propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	exports.default = WindowHeight;
	module.exports = exports['default'];

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  min-height: 100vh;\n  position: relative;\n  padding-bottom: 80px;\n'], ['\n  box-sizing: border-box;\n  min-height: 100vh;\n  position: relative;\n  padding-bottom: 80px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _header = __webpack_require__(1071);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(1069);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(1142);
	
	__webpack_require__(1143);
	
	var _rootProvider = __webpack_require__(527);
	
	var _rootProvider2 = _interopRequireDefault(_rootProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Layout.propTypes = {
	  children: _propTypes2.default.any,
	  data: _propTypes2.default.object.isRequired
	};
	
	function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  var _data$site$siteMetada = data.site.siteMetadata,
	      title = _data$site$siteMetada.title,
	      copyright = _data$site$siteMetada.copyright;
	  var _data$contacts = data.contacts,
	      phoneNumbers = _data$contacts.phoneNumbers,
	      address = _data$contacts.address,
	      email = _data$contacts.email;
	
	  var services = data.services.edges.map(function (_ref2) {
	    var node = _ref2.node;
	    return {
	      label: node.title,
	      url: node.fields.slug
	    };
	  });
	  var menu = getMenu(services, false);
	  return _react2.default.createElement(
	    _rootProvider2.default,
	    { titlePrefix: title },
	    _react2.default.createElement(
	      AppContainer,
	      null,
	      _react2.default.createElement(_header2.default, {
	        menu: menu,
	        phoneNumber: phoneNumbers[0],
	        email: email,
	        address: address
	      }),
	      children(),
	      _react2.default.createElement(_footer2.default, { copyright: copyright, menu: menu })
	    )
	  );
	}
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';
	
	var AppContainer = _styledComponents2.default.div(_templateObject);
	
	var getMenu = function getMenu(services, postsEnabled) {
	  return [{
	    label: 'Главная',
	    url: '/'
	  }, {
	    label: 'О компании',
	    url: '/about'
	  }, {
	    label: 'Услуги',
	    children: services
	  }, {
	    label: 'Полезная информация',
	    children: [{
	      label: 'Типы контейнеров',
	      url: '/helpful-information/container-types'
	    }]
	  }, postsEnabled && {
	    label: 'Новости',
	    url: '/news'
	  }, {
	    label: 'Контакты',
	    url: '/contacts'
	  }].filter(Boolean);
	};

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  xs: 0,
	  s: 480,
	  m: 728,
	  l: 1024,
	  xl: 1280
	};
	module.exports = exports["default"];

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-c6fc964fce911b83439e.js